import axios from 'axios'
import { Message } from 'element-ui'
import { gostlogin, gostportal } from '@jy/utils/gowhere'
import {
  showLoading,
  hideLoading
} from './loading'
const service = axios.create({
  baseURL: '/api', // url = base url + request url
  withCredentials: true, //  send cookies when cross-domain requests
  timeout: 20000 //  request timeout
})

service.interceptors.request.use(
  (config) => {
    // debugger
    showLoading() // 显示加载中
    const user = JSON.parse(localStorage.getItem('user'))
    const hasCookie = document.cookie.includes('SS_TICKET')
    if (user !== null && hasCookie === true) {
      var userid = JSON.parse(sessionStorage.getItem('userid'))
      if (userid) {
        // 有员工id
        if (userid !== user.userId) {
          // 登录了其他用户刷新页面
          alert('当前用户已切换，请点击确定刷新页面!')
          sessionStorage.setItem('userid', JSON.stringify(user.userId))
          gostportal() // 刷新页面
          return config
        } else {
          return config
        }
      } else {
        // 没有
        sessionStorage.setItem('userid', JSON.stringify(user.userId))
        return config
      }
    } else {
      // return config
      gostlogin()
    }
  },
  (error) => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    // 201禁止删除或者异常信息  403没有cookis    202 后端定义的特殊接口可以放过需要弹出错误信息     203 密码123456需要重置密码  500 服务器重启     400 参数异常      405 资源无权限
    if (
      res.status === 200 ||
      res.status === undefined ||
      res.status === 202 ||
      res.status === 203 ||
      res.status === 500
    ) {
      hideLoading() // 关闭加载
      return res
    } else if (res.status === 405 || res.status === 201 || res.status === 400) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 10 * 1000
      })
      return res
    } else if (res.status === 403) {
      // 403没有cookis
      hideLoading() // 关闭加载
      sessionStorage.clear()
      localStorage.clear()
      gostlogin()
      return res
    } else if (res.status === 406) {
      // 406 菜单没有接口没有权限访问
      hideLoading() // 关闭加载
      Message({
        message: res.msg,
        type: 'error',
        duration: 10 * 1000
      })
      window.open(
        window.location.protocol + '//' + window.location.host + '/#/Notauth',
        '_self'
      )
      return res
    }
  },
  (error) => {
    console.log(error)
    if (error.response.status === 403) {
      sessionStorage.clear()
      localStorage.clear()
      gostlogin()
      return error
    } else if (error.response.status === 404) {
      hideLoading() // 关闭加载
      Message({
        message: '404，请稍后再试!',
        type: 'error',
        duration: 10 * 1000
      })
      return error
    } else if (error.response.status === 500) {
      hideLoading() // 关闭加载
      // 系统异常请联系管理员
      Message({
        message: '系统异常，请稍后再试!',
        type: 'error',
        duration: 10 * 1000
      })
      return error
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }

    return Promise.reject(error)
  }
)

export default service
